import { Box, BoxProps, Text } from "@vinomofo/components";
import { ProxyIcon } from "@vinomofo/icons";
import styled from "styled-components";

interface IconBadgeProps extends BoxProps {
  iconName: string;
  label: string;
  backgroundColor?: string;
  color?: string;
}
const StyledText = styled(Text)`
  text-transform: capitalize;
  color: darkgrey;
  font-family: ${({ theme }) => theme.fonts.heading};
  text-align: center;
  display: block;
`;
export const IconBadge = ({
  iconName,
  label,
  color = "white",
  ...rest
}: IconBadgeProps): JSX.Element => {
  return (
    <Box display="flex" flexDirection="column" {...rest}>
      <Box
        width="60px"
        height="60px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        alignSelf="center"
        color={color}
      >
        <ProxyIcon iconName={iconName} size="60px" />
      </Box>
      <Box alignSelf="center" marginTop="8px">
        <StyledText forwardedAs="span" fontWeight={500} fontSize={[0, 1]}>
          {label}
        </StyledText>
      </Box>
    </Box>
  );
};
